import React from "react";

import { stylize } from "@envestnet/envreact-component-library";
import withIntl from "utils/withIntl";

import Logo from "images/EnvLogo";
import AuthenticatorHeader from "components/AuthenticatorHeader";
import PhoneAuthenticatorCodeSection from "components/PhoneAuthenticatorCodeSection";
import PhoneAuthenticatorSection from "components/PhoneAuthenticatorSection";
import { PhoneResponsePayload } from "types/PhoneAuthenticator";
import styles from "./styles";

type DefaultProps = {
  // Default props should always be required props, i.e. no ? indicating it's optional
  // The default values are specified below

  /** Description of this prop */

  loading: boolean;
  userName: string;
};

interface PhoneAuthProps {
  hideLogo: boolean;
  textMessageReceived: PhoneResponsePayload;
  cancelCallback: any;
  passCodeError: string | null;
  setPassCodeError: any;
  sendTextMessage: (phoneNumber: string) => void;
  loading: boolean;
  submitPassCode: (passcode: string) => void;
  restartPhone: () => void;
}

type Props = PhoneAuthProps & DefaultProps;
const PhoneAuth = (props: Props) => {
  const {
    hideLogo,
    userName,
    textMessageReceived,
    loading,
    sendTextMessage,
    cancelCallback,
    submitPassCode,
    passCodeError,
    setPassCodeError,
    restartPhone,
  } = props;
  return (
    <>
      {!hideLogo && <Logo />}
      <AuthenticatorHeader
        authenticatorName="phone authentication"
        userId={userName}
      />
      {textMessageReceived !== "SUCCESS" ? (
        <PhoneAuthenticatorSection
          sendButtonCallback={sendTextMessage}
          loading={loading}
          cancelCallback={cancelCallback}
          textMessageReceived={textMessageReceived}
        />
      ) : null}
      {textMessageReceived === "SUCCESS" ? (
        <PhoneAuthenticatorCodeSection
          loading={loading}
          cancelCallback={cancelCallback}
          verifyCallback={submitPassCode}
          passCodeError={passCodeError}
          setPassCodeError={setPassCodeError}
          restartPhone={restartPhone}
        />
      ) : null}
    </>
  );
};

export default withIntl(stylize<Props, DefaultProps>(styles)(PhoneAuth));
